export const generateStripeLinks = async ({ subscriptions, createdBy }) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/subscriptions/generate-links`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ subscriptions, createdBy }),
      }
    );

    if (!response.ok) throw new Error("Erreur lors de la génération");

    const data = await response.json();
    return data.links ?? [];
  } catch (err) {
    console.error("Erreur generateStripeLinks", err);
    throw err;
  }
};

export const fetchUserSubscriptions = async (userId) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/validate/${userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      console.error("Erreur HTTP :", response.status);
      return [];
    }

    const data = await response.json();
    return data.subscriptions || [];
  } catch (error) {
    console.error("Erreur fetchUserSubscriptions :", error);
    return [];
  }
};
